import QtdModulo from '../../ModulosCrefito/QtdModulo'
import TOPerfilAssistencia from '../../ModulosCrefito/ModulosTO/TOPerfilAssistencia'
import TOrecursos from '../../ModulosCrefito/ModulosTO/TOrecursos'
import TOregistroProntuario from '../../ModulosCrefito/ModulosTO/TOregistroProntuario'
import TOestagio from '../../ModulosCrefito/ModulosTO/TOestagio'
import TOpessoaNaoHabilitada from '../../ModulosCrefito/ModulosTO/TOpessoaNaoHabilitada'
import TOoutrosDados from '../../ModulosCrefito/ModulosTO/TOoutrosDados'
import TOorientacoes from '../../ModulosCrefito/ModulosTO/TOorientacoes'
import TOcapsPsicossocial from '../../ModulosCrefito/ModulosTO/TOcapsPsicossocial'
import TOresponsavelFisc from '../../ModulosCrefito/ModulosTO/TOresponsavelFisc'
import TOservicoNaUnidade from '../../ModulosCrefito/ModulosTO/TOservicoNaUnidade'
import TOprofissionaisNoEstabelecimento from '../../ModulosCrefito/ModulosTO/TOprofissionaisNoEstabelecimento'
import TOparametrosAssistenciais from '../../ModulosCrefito/ModulosTO/TOparametrosAssistenciais'
import TOrecursoEstrutura from '../../ModulosCrefito/ModulosTO/TOrecursoEstrutura'
import TOnasfModalidades from '../../ModulosCrefito/ModulosTO/TOnafsModalidade'
import TOnasfMunicipio from '../../ModulosCrefito/ModulosTO/TOnasfMunicipio'
import TOepi from '../../ModulosCrefito/ModulosTO/TOepi'
import TOuti from '../../ModulosCrefito/ModulosTO/TOuti'
import TOucin from '../../ModulosCrefito/ModulosTO/TOucin'
import TOoutrasUnidades from '../../ModulosCrefito/ModulosTO/TOoutrasUnidades'
import TOenfermaria from '../../ModulosCrefito/Modulos/TOenfermaria'
import TOambulatorio from '../../ModulosCrefito/ModulosTO/TOambulatorio'
import TOresidencia from '../../ModulosCrefito/ModulosTO/TOresidencia'
import TOexposicaoprofissional from '../../ModulosCrefito/ModulosTO/TOexposicaoprofissional'
import TOintervencoes from '../../ModulosCrefito/ModulosTO/TOintervencoes'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Livre = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="PERFIL DA ASSISTÊNCIA DE TERAPIA OCUPACIONAL" modulo="toperfilassistencia" />
            <TOPerfilAssistencia modulo="toperfilassistencia" />
            <QtdModulo texto="RECURSOS TERAPÊUTICOS / AMBIENTES DO SERVIÇO" modulo="torecursos" />
            <TOrecursos modulo="torecursos" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="toregistroprontuario" />
            <TOregistroProntuario modulo="toregistroprontuario" />
            <QtdModulo texto="ESTÁGIO" modulo="toestagio" />
            <TOestagio modulo="toestagio" />
            <QtdModulo texto="EXERCÍCIO ILEGAL" modulo="topessoanaohabilitada" />
            <TOpessoaNaoHabilitada modulo="topessoanaohabilitada" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="tooutrosDados" />
            <TOoutrosDados modulo="tooutrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/RECOMENDAÇÕES/NOTIFICAÇÕES" modulo="toorientacoes" />
            <TOorientacoes modulo="toorientacoes" />
            <QtdModulo texto="CENTRO DE ATENÇÃO PSICOSSOCIAL" modulo="tocapspsicossocial" />
            <TOcapsPsicossocial modulo="tocapspsicossocial" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="toresponsavelfisc" />
            <TOresponsavelFisc modulo="toresponsavelfisc" />
            <QtdModulo texto="SERVIÇOS NA UNIDADE" modulo="toserviconaunidade" />
            <TOservicoNaUnidade modulo="toserviconaunidade" />
            <QtdModulo texto="PROFISSIONAIS TERAPEUTAS OCUPACIONAIS" modulo="toprofissionaisnoestabelecimento" />
            <TOprofissionaisNoEstabelecimento modulo="toprofissionaisnoestabelecimento" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="toparametrosassistenciais" />
            <TOparametrosAssistenciais modulo="toparametrosassistenciais" />
            <QtdModulo texto="SETORES DA ASSISTÊNCIA - RECURSOS E ESTRUTA " modulo="torecursoest" />
            <TOrecursoEstrutura modulo="torecursoest" />
            <QtdModulo texto="MODALIDADE DE NASF-AB" modulo="tonasfmodalidade" />
            <TOnasfModalidades modulo="tonasfmodalidade" />
            <QtdModulo texto="SOBRE A ATUAÇÃO DO NASF NO MUNICÍPIO" modulo="tonasfmunicipio" />
            <TOnasfMunicipio modulo="tonasfmunicipio" />
            <QtdModulo texto="EPI" modulo="toepi" />
            <TOepi modulo="toepi" />
            <QtdModulo texto="UTI" modulo="touti" />
            <TOuti modulo="touti" />
            <QtdModulo texto="UCIN" modulo="toucin" />
            <TOucin modulo="toucin" />
            <QtdModulo texto="OUTRAS UNIDADES DE TERAPIA" modulo="tooutrasunidades" />
            <TOoutrasUnidades modulo="tooutrasunidades" />
            <QtdModulo texto="ENFERMARIA" modulo="toenfermaria" />
            <TOenfermaria modulo="toenfermaria" />
            <QtdModulo texto="AMBULATÓRIO" modulo="toambulatorio" />
            <TOambulatorio modulo="toambulatorio" />
            <QtdModulo texto="PROGRAMA DE RESIDÊNCIA" modulo="toresidencia" />
            <TOresidencia modulo="toresidencia" />
            <QtdModulo texto="EXPOSIÇÃO DOS PROFISSIONAIS A DOENÇAS INFECTO-CONTAGIOSAS " modulo="toexposicao" />
            <TOexposicaoprofissional modulo="toexposicao" />
            <QtdModulo texto="INTERVENÇÕES DA TERAPIA OCUPACIONAL " modulo="tointervencoes" />
            <TOintervencoes modulo="tointervencoes" />
        </>
    )
}

export default Livre
